export default {
  id: null,
  pessoa: null,
  telefone: null,
  card: null
}



// WEBPACK FOOTER //
// ./src/shared/models/crm/newLeadmodel.js